import React from 'react';
import { motion } from 'motion/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Linkedin, Mail, Youtube } from 'lucide-react';
import { Logo } from '../logos/Logo';
import './Footer.css';

const footer_links = {
  Product: [
    { name: 'Timeline Slicer', href: '#visuals' },
    { name: 'Countdown Timer', href: '#visuals' },
    // { name: 'Image Viewer', href: '#' },
    // { name: 'Browser Extensions', href: '#extensions' }
  ],
  // Support: [
  //   { name: 'Documentation', href: '#' },
  //   { name: 'Tutorials', href: '#' },
  //   { name: 'Community', href: '#' }
  // ],
  Company: [
    // { name: 'About', href: '/about' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact Support', href: '/contact' }
  ]
};

const social_links = [
  { icon: Linkedin, href: 'https://www.linkedin.com/in/iuliia-strunnikova/', label: 'LinkedIn' },
  { icon: Mail, href: 'mailto:support@based-on.net', label: 'Email' },
  { icon: Youtube, href: 'https://www.youtube.com/@based-on', label: 'YouTube' }
];

export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleProductClick = (href: string) => {
    if (href === '#visuals') {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const visualsSection = document.getElementById('visuals');
          if (visualsSection) {
            visualsSection.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        const visualsSection = document.getElementById('visuals');
        if (visualsSection) {
          visualsSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-grid">
          <motion.div
            className="site-footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Logo />
            <p>
              Empowering data professionals with practical Power BI visuals that make reports
              clearer, faster, and easier to use.
            </p>

            <div className="site-footer-social">
              {social_links.map((social, index) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3, delay: index * 0.08 }}
                    viewport={{ once: true }}
                    target={social.href.startsWith('mailto:') ? '_self' : '_blank'}
                    rel={social.href.startsWith('mailto:') ? undefined : 'noopener noreferrer'}
                  >
                    <Icon size={18} />
                  </motion.a>
                );
              })}
            </div>
          </motion.div>

          {Object.entries(footer_links).map(([category, links], categoryIndex) => (
            <motion.div
              key={category}
              className="site-footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: categoryIndex * 0.1 }}
              viewport={{ once: true }}
            >
              <h4>{category}</h4>
              <ul>
                {links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.href === '#visuals' ? (
                      <button
                        type="button"
                        onClick={() => handleProductClick(link.href)}
                      >
                        {link.name}
                      </button>
                    ) : (
                      <a href={link.href}>
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="site-footer-bottom"
        >
          <div>© 2025 BasedOn. All rights reserved.</div>
          
          <div className="site-footer-legal">
            <button 
              type="button"
              onClick={() => navigate('/privacy')} 
            >
              Privacy Policy
            </button>
          </div>
        </motion.div>
      </div>
    </footer>
  );
}
